/**
 * Playback-time helpers shared by the player UI (T2).
 */

/**
 * Format a number of seconds as m:ss (e.g. 125 -> "2:05").
 * @param {number} seconds
 * @returns {string}
 */
export const formatTime = (seconds) => {
  if (!seconds || seconds === 0 || !isFinite(seconds)) return '0:00';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * Parse an <itunes:duration> value into seconds.
 * Accepts "H:MM:SS", "M:SS" or plain seconds ("225").
 * @param {string|null|undefined} duration
 * @returns {number|null} seconds, or null when unparseable
 */
export const parseItunesDuration = (duration) => {
  if (!duration) return null;
  if (duration.includes(':')) {
    const parts = duration.split(':').map(Number);
    if (parts.some((p) => isNaN(p))) return null;
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    return null;
  }
  const n = parseInt(duration, 10);
  return isNaN(n) ? null : n;
};
